<template>
  <v-card>
    <v-card-title class='body-1 fontcolor'>Search Logs:</v-card-title>
    <template class="ma-2" >
      <v-row class=" ml-4" >
        <v-col class="d-flex" cols="2" lg="2" sm="2" >
          <v-menu
            ref='menu'
            v-model='menu'
            :close-on-content-click='false'
            :return-value.sync='filterItem.fromDate'
            transition='scale-transition'
            offset-x
          >
            <template v-slot:activator='{ on }'>
              <v-text-field
                class="pt-0"
                v-model='filterItem.fromDate'
                label='From Date'
                prepend-icon='mdi-calendar'
                readonly
                v-on='on'
              ></v-text-field>
            </template>
            <v-date-picker
              v-model='filterItem.fromDate'
              hint=' Please select an From Date'
              persistent-hint
              no-title
              scrollable
            >
            <v-btn text color='error' @click='menu = false'>Cancel</v-btn>
            <v-btn text color='success' @click='$refs.menu.save(filterItem.fromDate)'>OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="d-flex" cols="2" lg="2" sm="2" >
          <v-menu
            ref='menu2'
            v-model='menu2'
            :close-on-content-click='false'
            :return-value.sync='filterItem.toDate'
            transition='scale-transition'
            offset-x
          >
            <template v-slot:activator='{ on }'>
              <v-text-field
                class="pt-0"
                v-model='filterItem.toDate'
                label='To Date'
                prepend-icon='mdi-calendar'
                readonly
                v-on='on'
              ></v-text-field>
            </template>
            <v-date-picker
              v-model='filterItem.toDate'
              hint=' Please select an To Date'
              persistent-hint
              no-title
              scrollable
            >
            <v-btn text color='error' @click='menu2 = false'>Cancel</v-btn>
            <v-btn text color='success' @click='$refs.menu2.save(filterItem.toDate)'>OK</v-btn>
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="d-flex" cols="2" lg="2" sm="2">
          <v-autocomplete
          class="caption"
          v-model="filterItem.userBy"
            :items='userList'
            label="By User"
            item-text='email'
            item-value='id'
            dense
          ></v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="2" lg="2" sm="2">
          <v-autocomplete
          class="caption"
          v-model="filterItem.actionBy"
            :items='actionList'
            label="By Action"
            item-text='name'
            item-value='id'
            dense
          ></v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="2" lg="2" sm="2">
          <v-autocomplete
          class="caption"
          v-model="filterItem.entityBy"
            :items='moduleList'
            label="By Entity"
            item-text='title'
            item-value='id'
            dense
          ></v-autocomplete>
        </v-col>
        <v-col >
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
            <v-btn  v-on="on" fab small class='mb-2 mr-4 text-lg-right' color="success" @click="filterRecords">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
            </template>
            <span>Search</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" fab small class='mb-2 mr-2 text-lg-right' color="grey lighten-1" @click="initialize">
                <v-icon>mdi-cached</v-icon>
              </v-btn>
            </template>
            <span>Reset</span>
          </v-tooltip>
        </v-col>
      </v-row>
    <v-data-table
    :loading='dataLoading'
    :headers='headers'
    hide-default-header
    :items='auditRecordList'
    :page.sync="page"
    :options.sync= "options"
    :server-items-length="totalRecords"
    :items-per-page="itemsPerPage"
    class='elevation-1'
    :footer-props="{'items-per-page-options': rowsPerPageItems}"
    :expanded.sync="expanded"
    item-key="id"
    show-expand
    id="aLTab"
    >
      <template v-slot:top>
        <v-toolbar flat id='manageTable'>
          <v-toolbar-title class='display-1 fontcolor'>{{TABLE_TITLE}}</v-toolbar-title>
        </v-toolbar>
      </template>
      <template v-slot:item.message="{ item }">
        <td class="font-weight-medium" style="border-bottom:0px;" >{{ item.message }}</td>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-simple-table dense >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Old Value</th>
                  <th class="text-left">New Value</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(ite,index) in item.allValues" :key="index">
                  <td class="caption" style="text-transform: capitalize" >
                    {{ $globalStates.splitFromFirstCapitalChar(ite.columnName) }}
                  </td>
                  <td class="caption" v-if="ite.prevValue" >
                    {{ ite.prevValue }}
                  </td>
                  <td v-else >--</td>
                  <td v-if='ite.columnName === "password"' class="caption" >
                    xxxxx
                  </td>
                  <td v-else class="caption" >{{ ite.newValue ? ite.newValue : '--' }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </td>
      </template>
      <template v-slot:no-data>
        <p>{{NO_DATA_FOUND}}</p>
      </template>
    </v-data-table>
    </template>
    <v-spacer></v-spacer>
  </v-card>
</template>

<script>
import CONSTANTS from './../../../../config/constant'

export default {
  name: 'AdminAuditDataLogs',
  data: () => ({
    TABLE_TITLE: CONSTANTS.VIEW_AUDIT_LOGS,
    NO_DATA_FOUND: CONSTANTS.NO_DATA_FOUND,
    expanded: [],
    singleExpand: false,
    menu: false,
    menu2: false,
    dataLoading: false,
    actionsList: [],
    modulesList: [],
    editedIndex: -1,
    rowsPerPageItems: [5, 10, 20, 50, 100],
    options: {},
    page: 1,
    totalRecords: 0,
    itemsPerPage: 10,
    queryParams: '',
    headers: [
      {
        text: '',
        align: 'left',
        sortable: false,
        value: 'message',
        class: 'subtitle-2'
      },
      { text: '', value: 'data-table-expand' }
    ],
    filterItem: {
      fromDate: '',
      toDate: '',
      userBy: '',
      userId: '',
      actionBy: '',
      entityBy: ''
    },
    defaultItem: {
      fromDate: '',
      toDate: '',
      userBy: '',
      userId: '',
      actionBy: '',
      entityBy: ''
    }
  }),
  mounted () {
    this.initialize()
  },
  watch: {
    options: {
      handler () {
        const formData = {
          fromDate: this.filterItem.fromDate === undefined ? '' : this.filterItem.fromDate,
          toDate: this.filterItem.toDate === undefined ? '' : this.filterItem.toDate,
          userBy: this.filterItem.userBy === undefined ? '' : this.filterItem.userBy,
          actionBy: this.filterItem.actionBy === undefined ? '' : this.filterItem.actionBy,
          entityBy: this.filterItem.entityBy === undefined ? '' : this.filterItem.entityBy
        }
        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        const { fromDate, toDate, userBy, actionBy, entityBy } = formData
        if (sortBy.length === 1 || sortDesc.length === 1 || page !== 1 || itemsPerPage) {
          this.queryParams = `?page=${page}&itemsPerPage=${itemsPerPage}&fDate=${fromDate}&tDate=${toDate}&uBy=${userBy}&aBy=${actionBy}&eBy=${entityBy}`
        }
        this.$store.commit('AuditLogModule/addQueryParams', this.queryParams)
        new Promise((resolve, reject) => {
          this.$store.dispatch('AuditLogModule/getAuditLogList', {
            resolve,
            reject
          })
        })
          .then(responseData => {
            this.totalRecords = responseData.pagination.totalRecords
            this.dataLoading = false
          })
          .catch(error => {
            this.dataLoading = false
            this.$globalStates.notification.type = 'error'
            if (error.response.status === 404) {
              this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText('')
            } else {
              this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(error.responseMessage)
            }
            this.$globalStates.notification.init_notifications = true
          })
      },
      deep: true
    }
  },
  computed: {
    // to get logged in user ID
    userId () {
      return this.$store.getters['AuthModule/getUserId']
    },
    getQueryParams () {
      return this.$store.getters['AuditLogModule/fetchQueryParams']
    },
    userList () {
      return this.$store.getters['UserModule/fetchUserList']
    },
    auditRecordList () {
      return this.$store.getters['AuditLogModule/fetchAuditLogList']
    },
    moduleList () {
      return this.modulesList
    },
    actionList () {
      return this.actionsList
    }
  },
  methods: {
    // dispatch an action in below method to fetch audit data list
    initialize () {
      Object.assign(this.filterItem, this.defaultItem)
      new Promise((resolve, reject) => {
        this.$store.dispatch('UserModule/getUserList', {
          resolve,
          reject
        })
      })
        .then(responseData => {
          // add loader on button if required
        })
        .catch(({ response }) => {
          // add loader on button if required
        })
      new Promise((resolve, reject) => {
        this.$store.dispatch('AuditLogModule/getAuditFilterslList', {
          resolve,
          reject
        })
      })
        .then(responseData => {
          this.actionsList = responseData.list.actionsList
          this.modulesList = responseData.list.modulesList
        })
        .catch(response => {
        })
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      if (sortBy.length === 1 || sortDesc.length === 1 || page !== 1 || itemsPerPage) {
        this.queryParams = `?page=${page}&itemsPerPage=${itemsPerPage}`
      }
      this.$store.commit('AuditLogModule/addQueryParams', this.queryParams)
      new Promise((resolve, reject) => {
        this.$store.dispatch('AuditLogModule/getAuditLogList', {
          resolve,
          reject
        })
      })
        .then(responseData => {
          this.totalRecords = responseData.pagination.totalRecords
          this.dataLoading = false
        })
        .catch(error => {
          this.dataLoading = false
          this.$globalStates.notification.type = 'error'
          if (error.response.status === 404) {
            this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText('')
          } else {
            this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(error.responseMessage)
          }
          this.$globalStates.notification.init_notifications = true
        })
    },
    // On Click of Search Filter Button
    filterRecords () {
      const formData = {
        fromDate: this.filterItem.fromDate === undefined ? '' : this.filterItem.fromDate,
        toDate: this.filterItem.toDate === undefined ? '' : this.filterItem.toDate,
        userBy: this.filterItem.userBy === undefined ? '' : this.filterItem.userBy,
        actionBy: this.filterItem.actionBy === undefined ? '' : this.filterItem.actionBy,
        entityBy: this.filterItem.entityBy === undefined ? '' : this.filterItem.entityBy
      }
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      const { fromDate, toDate, userBy, actionBy, entityBy } = formData
      if (sortBy.length === 1 || sortDesc.length === 1 || page !== 1 || itemsPerPage) {
        this.queryParams = `?page=1&itemsPerPage=${itemsPerPage}&fDate=${fromDate}&tDate=${toDate}&uBy=${userBy}&aBy=${actionBy}&eBy=${entityBy}`
      }
      this.$store.commit('AuditLogModule/addQueryParams', this.queryParams)
      new Promise((resolve, reject) => {
        this.$store.dispatch('AuditLogModule/getAuditLogList', {
          resolve,
          reject
        })
      })
        .then(responseData => {
          this.totalRecords = responseData.pagination.totalRecords
          this.dataLoading = false
        })
        .catch(error => {
          this.dataLoading = false
          this.$globalStates.notification.type = 'error'
          if (error.response.status === 404) {
            this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText('')
          } else {
            this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(error.responseMessage)
          }
          this.$globalStates.notification.init_notifications = true
        })
    }
  }
}
</script>
<style>
.v-data-table tbody tr.v-data-table__expanded__content{
  box-shadow: none !important
}
</style>
